import React from "react";

type ColumnFiltersBadgeProps = {
  count: number;
};

export const ColumnFiltersBadge: React.FC<ColumnFiltersBadgeProps> = ({ count }) => {
  if (count <= 0) return null;
  return (
    <span
      style={{
        position: "absolute",
        top: -6,
        right: -6,
        minWidth: 20,
        height: 20,
        background: "red",
        color: "white",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: "bold",
        zIndex: 2,
        pointerEvents: "none",
        boxShadow: "0 0 0 2px white"
      }}
      data-testid="column-filter-badge"
    >
      {count}
    </span>
  );
};